import { useEffect, useState } from "react";
import {
  Table,
  Card,
  CardBody,
  Badge,
  Button,
  Spinner,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Col,
  Row
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getEnquiryDetailsApi, getFeesListApi } from "../../../api/apiUrlConst";
import { startSignalRConnection } from "../../../service/signalrService";
import AddPaymentModal from "./AddPaymentModal";

const FeesCollection = () => {
  const [feesList, setFeesList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [paymentModal, setPaymentModal] = useState(false);
  const [selectedFee, setSelectedFee] = useState<any>(null);
  const [search, setSearch] = useState("");
  const [filteredList, setFilteredList] = useState<any[]>([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [data, setData] = useState<any>(null);
  const [viewModal, setViewModal] = useState(false);

  const enquiry = data?.enquiry;
  const followUps = data?.followUps;
  const fees = data?.fees;
  const payments = data?.payments;


  const loadDetails = async (eid: string) => {
    try {
      setLoading(true);
      const res = await getEnquiryDetailsApi(eid);
      setData(res);
      setViewModal(true);
    } catch {
      toast.error("Failed to load enquiry details");
    } finally {
      setLoading(false);
    }
  };
  const loadData = async () => {
    try {
      const data = await getFeesListApi();
      setFeesList(data);
      setFilteredList(data);
    } catch {
      toast.error("Failed to load fees list");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    startSignalRConnection();
  }, []);

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Joined": return "success";
      case "InFollowUp": return "warning";
      case "NotInterested": return "danger";
      case "Assigned": return "primary";
      case "DND": return "dark";
      default: return "secondary";
    }
  };
useEffect(() => {
  let data = [...feesList];

  // 🔍 Search filter
  if (search) {
    const searchLower = search.toLowerCase();

    data = data.filter((f) =>
      f.enqFormId?.toString().toLowerCase().includes(searchLower) ||
      f.name?.toString().toLowerCase().includes(searchLower) ||
      f.course?.toString().toLowerCase().includes(searchLower) ||
      f.status?.toString().toLowerCase().includes(searchLower) ||
      f.phoneNo?.toString().includes(searchLower) ||
      f.totalFees?.toString().includes(searchLower) ||
      f.paidAmount?.toString().includes(searchLower) ||
      f.pendingAmount?.toString().includes(searchLower)
    );
  }

   const today = new Date();
  today.setHours(0,0,0,0);

  // 🎯 Status filter
if (statusFilter) {
  data = data.filter((f) => {

    const isOverdue =
      f.nextDueDate &&
      new Date(f.nextDueDate) < new Date() &&
      f.pendingAmount > 0;

    const status = f.isFullyPaid
      ? "FullyPaid"
      : isOverdue
      ? "Overdue"
      : "Pending";

    return status === statusFilter;
  });
}

  

  // ⭐ Sort by Closest Next Due Date
  data.sort((a, b) => {
    const dateA = a.nextDueDate ? new Date(a.nextDueDate).getTime() : Infinity;
    const dateB = b.nextDueDate ? new Date(b.nextDueDate).getTime() : Infinity;

    return dateA - dateB;
  });

  setFilteredList(data);

}, [search, statusFilter, feesList]);

const Clearfilter=  () => {
  setSearch("");
  setStatusFilter("");
};

  if (loading) return <Spinner className="mt-5" />;

  return (
    <div  style={{ background: "#f4f6fb", minHeight: "100vh" }}>

      {/* ===== HEADER ===== */}
      <div
        className="p-4 mb-4"
        style={{
          background: "linear-gradient(90deg, #374151, #093d92)",
          borderRadius: "16px",
          color: "#fff",
        }}
      >
        {/* Title Section */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">

          {/* Left Side */}
          <div>
            <h3 className="fw-bold mb-1">Fees Collection</h3>
            <small>Track payments and pending balances</small>
          </div>

          {/* Right Side Filters */}
          <div className="d-flex gap-3 mt-3 mt-md-0">

            <Input
              placeholder="🔍 Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="rounded-pill shadow-sm"
              style={{ width: "250px" }}
            />

            <Input
              type="select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="rounded-pill shadow-sm"
              style={{ width: "180px" }}
            >
              <option value="">All Status</option>
              <option value="FullyPaid">Fully Paid</option>
              <option value="Pending">Pending</option>
              <option value="Overdue">Overdue</option>
            </Input>
             <Button 
            className="d-flex gap-3 mt-3 mt-md-0"
            color="primary"
            onClick={Clearfilter}
            >Clear</Button>

          </div>
        </div>
      </div>

      {/* ===== SUMMARY CARDS ===== */}
      <div className="row mb-4">
        <div className="col-md-3">
          <Card className="border-0 shadow-sm rounded-4">
            <CardBody className="text-center">
              <div className="text-muted">Total Revenue</div>
              <h5 className="fw-bold">
                ₹ {feesList.reduce((a, b) => a + b.totalFees, 0)}
              </h5>
            </CardBody>
          </Card>
        </div>

        <div className="col-md-3">
          <Card className="border-0 shadow-sm rounded-4">
            <CardBody className="text-center">
              <div className="text-muted">Total Paid</div>
              <h5 className="fw-bold text-success">
                ₹ {feesList.reduce((a, b) => a + b.paidAmount, 0)}
              </h5>
            </CardBody>
          </Card>
        </div>

        <div className="col-md-3">
          <Card className="border-0 shadow-sm rounded-4">
            <CardBody className="text-center">
              <div className="text-muted">Total Pending</div>
              <h5 className="fw-bold text-danger">
                ₹ {feesList.reduce((a, b) => a + b.pendingAmount, 0)}
              </h5>
            </CardBody>
          </Card>
        </div>

        <div className="col-md-3">
          <Card className="border-0 shadow-sm rounded-4">
            <CardBody className="text-center">
              <div className="text-muted">Overdue</div>
              <h5 className="fw-bold text-warning">
                {
                  feesList.filter(
                    (f) =>
                      f.nextDueDate &&
                      new Date(f.nextDueDate) < new Date() &&
                      f.pendingAmount > 0
                  ).length
                }
              </h5>
            </CardBody>
          </Card>
        </div>
      </div>

      {/* ===== TABLE ===== */}
      <Card
        className="border-0 shadow-sm"
        style={{ borderRadius: "16px" }}
      >
        <CardBody>
          <Table
            responsive
            hover
            className="align-middle"
            style={{
              borderCollapse: "separate",
              borderSpacing: "0 8px",
            }}
          >
            <thead>
              <tr style={{ background: "#eef2f7" }}>
                <th>Enquiry ID</th>
                <th>Name</th>
                <th>Course</th>
                <th>Phone No</th>
                <th>Account</th>
                <th>Total</th>
                <th>Paid</th>
                <th>Pending</th>
                <th>Next Due</th>
                <th>Status</th>
                <th className="text-end">Action</th>
              </tr>
            </thead>

            <tbody>
              {feesList.length === 0 && (
                <tr>
                  <td colSpan={7} className="text-center text-muted py-4">
                    No fees records found
                  </td>
                </tr>
              )}

              {filteredList.map((f) => {
                const isOverdue =
                  f.nextDueDate &&
                  new Date(f.nextDueDate) < new Date() &&
                  f.pendingAmount > 0;

                return (
                  <tr
                    key={f.id}
                    style={{
                      background: "#fff",
                      boxShadow:
                        "0 2px 10px rgba(0,0,0,0.03)",
                      borderLeft: isOverdue
                        ? "5px solid #dc3545"
                        : "5px solid transparent",
                    }}
                  >
                    {/* Enquiry ID */}
                    <td className="fw-bold text-primary">
                      {f.eid}
                    </td>
                    {/* Name */}
                    <td className="fw-semibold">
                      {f.name}
                    </td>
                    {/* Courses */}
                    <td className="fw-semibold">
                      {f.course}
                    </td>
                    {/* Phone No */}
                    <td className="fw-semibold">
                      {f.phoneNo}
                    </td>

                    {/* Account */}
                    <td className="fw-semibold">
  {f.payments?.[0]?.account}
</td>
                    {/* Total */}
                    <td className="fw-semibold">
                      ₹ {f.totalFees}
                    </td>

                    {/* Paid */}
                    <td className="text-success fw-semibold">
                      ₹ {f.paidAmount}
                    </td>

                    {/* Pending */}
                    <td
                      className={
                        f.pendingAmount > 0
                          ? "text-danger fw-semibold"
                          : ""
                      }
                    >
                      ₹ {f.pendingAmount}
                    </td>

                    {/* Next Due */}
                    <td
                      className={
                        isOverdue
                          ? "fw-bold text-danger"
                          : ""
                      }
                    >
                      {f.nextDueDate
                        ? new Date(
                          f.nextDueDate
                        ).toLocaleDateString()
                        : "-"}
                    </td>

                    {/* Status */}
                    <td>
                      {f.isFullyPaid ? (
                        <Badge
                          color="success"
                          className="px-3 py-2 rounded-pill"
                        >
                          Fully Paid
                        </Badge>
                      ) : isOverdue ? (
                        <Badge
                          color="danger"
                          className="px-3 py-2 rounded-pill"
                        >
                          Overdue
                        </Badge>
                      ) : (
                        <Badge
                          color="warning"
                          className="px-3 py-2 rounded-pill"
                        >
                          Pending
                        </Badge>
                      )}
                    </td>

                    {/* Action */}
                    <td className="text-end">
                      <div className="d-flex justify-content-end gap-2">
                        <Button
                          size="sm"
                          className="rounded-pill"
                          color="info"
                          onClick={() => loadDetails(f.eid)}
                        >
                          View
                        </Button>

                        {!f.isFullyPaid && (
                          <Button
                            size="sm"
                            className="rounded-pill"
                            style={{
                              background:
                                "linear-gradient(90deg,#374151, #093d92)",
                              border: "none",
                            }}
                            onClick={() => {
                              setSelectedFee(f);
                              setPaymentModal(true);
                            }}
                          >
                            Add Payment
                          </Button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="xl">

        {/* HEADER */}
        <ModalHeader
          toggle={() => setViewModal(false)}
          style={{
            background: "linear-gradient(90deg,#374151,#093d92)",
            color: "#fff",
            borderBottom: "none"
          }}
        >
          🎓 Student Payment History
        </ModalHeader>

        <ModalBody style={{ background: "#f4f6fb", padding: "30px" }}>

          {!data ? (
            <div className="text-center p-5">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              {/* ================= Overview ================= */}
              <Card
                className="border-0 shadow-sm mb-4"
                style={{ borderRadius: "16px" }}
              >
                <CardBody>

                  <Row className="align-items-center">

                    {/* Avatar */}
                    <Col md="auto">
                      <div
                        style={{
                          width: 70,
                          height: 70,
                          borderRadius: "50%",
                          background: "linear-gradient(135deg,#374151,#093d92)",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 26,
                          fontWeight: "bold"
                        }}
                      >
                        {enquiry.name?.charAt(0)}
                      </div>
                    </Col>

                    {/* Details */}
                    <Col md={5}>
                      <h4 className="fw-bold mb-1">{enquiry.name}</h4>
                      <div className="text-muted">{enquiry.email}</div>
                      <div className="text-muted">{enquiry.phoneNumber}</div>
                    </Col>

                    {/* Status */}
                    <Col md={4} className="text-md-end">
                      <Badge
                        color={getStatusColor(enquiry.status)}
                        className="px-3 py-2 rounded-pill"
                        style={{ fontSize: "13px" }}
                      >
                        {enquiry.status}
                      </Badge>

                      <div className="mt-3 text-muted">
                        <div><strong>EID:</strong> {enquiry.eid}</div>
                        <div><strong>Coordinator:</strong> {enquiry.coordinatorName}</div>
                      </div>
                    </Col>

                  </Row>

                  <hr />

                  <Row>
                    <Col md={6}>
                      <strong>Course:</strong>{" "}
                      {enquiry.courseCategory} - {enquiry.courseName}
                    </Col>

                    <Col md={6}>
                      <strong>Submitted:</strong>{" "}
                      {new Date(enquiry.submittedAt).toLocaleDateString()}
                    </Col>
                  </Row>

                </CardBody>
              </Card>
              {/* ================= Fees ================= */}
              {fees && (
                <Row className="mb-4">

                  <Col md={3}>
                    <Card className="border-0 shadow-sm text-center">
                      <CardBody>
                        <div className="text-muted">Total Fees</div>
                        <h4 className="fw-bold">₹ {fees.totalFees}</h4>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md={3}>
                    <Card className="border-0 shadow-sm text-center">
                      <CardBody>
                        <div className="text-muted">Paid</div>
                        <h4 className="fw-bold text-success">
                          ₹ {fees.paidAmount}
                        </h4>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md={3}>
                    <Card className="border-0 shadow-sm text-center">
                      <CardBody>
                        <div className="text-muted">Pending</div>
                        <h4 className="fw-bold text-danger">
                          ₹ {fees.pendingAmount}
                        </h4>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md={3}>
                    <Card className="border-0 shadow-sm text-center">
                      <CardBody>
                        <div className="text-muted">Status</div>
                        {fees.isFullyPaid ? (
                          <Badge color="success" pill>Fully Paid</Badge>
                        ) : (
                          <Badge color="warning" pill>Pending</Badge>
                        )}
                      </CardBody>
                    </Card>
                  </Col>

                </Row>
              )}

              {/* ================= Payments ================= */}
              <Card className="border-0 shadow-sm">
                <CardBody>

                  <h5 className="fw-bold mb-3">
                    💳 Payment History
                  </h5>

                  <Table
                    responsive
                    hover
                    className="align-middle"
                    style={{
                      borderCollapse: "separate",
                      borderSpacing: "0 8px"
                    }}
                  >
                    <thead>
                      <tr style={{ background: "#eef2f7" }}>
                        <th>Date</th>
                        <th>Amount</th>
                        <th>Mode</th>
                        <th>Transaction ID</th>
                        <th>Account</th>
                      </tr>
                    </thead>

                    <tbody>
                      {payments.map((p: any, index: number) => (
                        <tr
                          key={index}
                          style={{
                            background: "#fff",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
                          }}
                        >
                          <td>{new Date(p.paidDate).toLocaleDateString()}</td>

                          <td className="fw-bold text-success">
                            ₹ {p.amount}
                          </td>

                          <td>
                            <Badge color="info" pill>
                              {p.mode}
                            </Badge>
                          </td>

                          <td>{p.transactionId}</td>

                          <td>
                            {p.account ? (
                              <span className="badge bg-light text-dark px-3 py-2 rounded-pill">
                                {p.account}
                              </span>
                            ) : "-"}
                          </td>

                        </tr>
                      ))}
                    </tbody>

                  </Table>

                </CardBody>
              </Card>
            </>
          )}

        </ModalBody>
      </Modal>

      {/* Payment Modal */}
      {selectedFee && (
        <AddPaymentModal
          isOpen={paymentModal}
          toggle={() => {
            setPaymentModal(!paymentModal);
            setSelectedFee(null);
          }}
          enqFormId={selectedFee.enqFormId}
          pendingAmount={selectedFee.pendingAmount}
          onSuccess={loadData}
        />
      )}
    </div>
  );
};

export default FeesCollection;